/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { EOrigineSuiviListSearch } from './EOrigineSuiviListSearch';
import {
    EOrigineSuiviListSearchFromJSON,
    EOrigineSuiviListSearchFromJSONTyped,
    EOrigineSuiviListSearchToJSON,
} from './EOrigineSuiviListSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface DashboardCentreNotificationsSearch
 */
export interface DashboardCentreNotificationsSearch {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardCentreNotificationsSearch
     */
    beneficiaire?: UnaccentTextSearch;
    /**
     * 
     * @type {EOrigineSuiviListSearch}
     * @memberof DashboardCentreNotificationsSearch
     */
    origineSuivi?: EOrigineSuiviListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardCentreNotificationsSearch
     */
    idrealisateurSuivi?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardCentreNotificationsSearch
     */
    idencodeur?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardCentreNotificationsSearch
     */
    idtypeSuivi?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardCentreNotificationsSearch
     */
    idsousTypeSuivi?: Int32ListSearch;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardCentreNotificationsSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardCentreNotificationsSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardCentreNotificationsSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCentreNotificationsSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCentreNotificationsSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardCentreNotificationsSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCentreNotificationsSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardCentreNotificationsSearch interface.
 */
export function instanceOfDashboardCentreNotificationsSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCentreNotificationsSearchFromJSON(json: any): DashboardCentreNotificationsSearch {
    return DashboardCentreNotificationsSearchFromJSONTyped(json, false);
}

export function DashboardCentreNotificationsSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCentreNotificationsSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'beneficiaire': !exists(json, 'beneficiaire') ? undefined : UnaccentTextSearchFromJSON(json['beneficiaire']),
        'origineSuivi': !exists(json, 'origineSuivi') ? undefined : EOrigineSuiviListSearchFromJSON(json['origineSuivi']),
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : Int32ListSearchFromJSON(json['idrealisateurSuivi']),
        'idencodeur': !exists(json, 'idencodeur') ? undefined : Int32ListSearchFromJSON(json['idencodeur']),
        'idtypeSuivi': !exists(json, 'idtypeSuivi') ? undefined : Int32ListSearchFromJSON(json['idtypeSuivi']),
        'idsousTypeSuivi': !exists(json, 'idsousTypeSuivi') ? undefined : Int32ListSearchFromJSON(json['idsousTypeSuivi']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardCentreNotificationsSearchToJSON(value?: DashboardCentreNotificationsSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'beneficiaire': UnaccentTextSearchToJSON(value.beneficiaire),
        'origineSuivi': EOrigineSuiviListSearchToJSON(value.origineSuivi),
        'idrealisateurSuivi': Int32ListSearchToJSON(value.idrealisateurSuivi),
        'idencodeur': Int32ListSearchToJSON(value.idencodeur),
        'idtypeSuivi': Int32ListSearchToJSON(value.idtypeSuivi),
        'idsousTypeSuivi': Int32ListSearchToJSON(value.idsousTypeSuivi),
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

